import React, { useState, useEffect } from 'react';
import { 
  ShieldCheck, School, Lock, ChevronRight, FileText, ChevronDown, 
  Brain, BarChart, Check, Star, X, Layers, ShieldAlert, Archive, Users, Zap, HelpCircle, MessageCircle
} from 'lucide-react';
// YENİ EKLENEN: Firebase'den onaylı yorumları çekmek için fonksiyon (Yolunu kendi projene göre kontrol et)
import { getPublicTestimonials } from '../firebase';

const LandingPage = ({ onSelect }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [testimonials, setTestimonials] = useState([]); // Vitrin Yorumları State'i

  // YENİ EKLENEN: Başlangıç için şık örnek (Mock) yorumlar
  const mockTestimonials = [
    { id: 'm1', userName: "Ayşe K.", userSchool: "İlkokul", message: "Rehber360 sayesinde RİBA raporlarını günlerce tek tek saymaktan kurtuldum. Kağıt işi tamamen bitti!" },
    { id: 'm2', userName: "M. T.", userSchool: "Anadolu Lisesi", message: "Yapay zeka analizleri veli görüşmelerinde elimi o kadar güçlendirdi ki, idaremiz bile şaşkın." },
    { id: 'm3', userName: "Burak C.", userSchool: "Ortaokul", message: "Sosyometriyi manuel çizmek tam bir işkenceydi. Şimdi sınıf ağım 5 saniyede önümde hazır." },
    { id: 'm4', userName: "Ece Y.", userSchool: "Meslek Lisesi", message: "Kurumsal analiz ve sınıf risk haritalarını hazırlamak artık 10 dakikamı bile almıyor. Harika!" },
    { id: 'm5', userName: "Serkan A.", userSchool: "Özel Okul", message: "Öğrenciler envanterleri ceplerinden çözüyor, analiz anında bende. Teknolojinin tam karşılığı." }
  ];

  // YENİ EKLENEN: Gerçek Yorumları Firebase'den Çekme Motoru
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const realFeedbacks = await getPublicTestimonials();
        if (realFeedbacks && realFeedbacks.length >= 3) {
          setTestimonials(realFeedbacks); // 3'ten fazla gerçek yorum varsa onları göster
        } else {
          // Gerçek yorum azsa veya yoksa örneklerle harmanla
          setTestimonials([...(realFeedbacks || []), ...mockTestimonials]);
        }
      } catch (error) {
        console.error("Yorumlar çekilemedi:", error);
        setTestimonials(mockTestimonials); // Hata olursa örnekleri göster
      }
    };
    fetchTestimonials();
  }, []);

  const faqs = [
    { q: "Öğrenci verileri nasıl korunuyor?", a: "Sistemimiz Firebase güvenlik altyapısı ile uçtan uca şifreleme kullanır. KVKK uyumludur ve hiçbir veri üçüncü şahıs şirketlerle veya reklam sağlayıcılarla paylaşılmaz." },
    { q: "Yapay zeka (AI) değerlendirmeleri kesin tanı mıdır?", a: "Hayır. Gemini AI modelimiz PDR terminolojisine uygun olarak tasarlanmış bir asistandır. Kesinlikle tıbbi bir teşhis koymaz, uzmanların yükünü hafifletmek için risk taraması ve taslak rapor sunar. Son karar daima PDR uzmanına aittir." },
    { q: "Ücretsiz sürümde sınırlar nelerdir?", a: "Ücretsiz sürümde Öğrenci Bilgi Formunu uygulayabilir, belirli sayıda envanter uygulayabilir ve görüntüleyebilirsiniz. Sistemin arayüzünü test edebilirsiniz. Gelişmiş envanterler, yapay zeka analizleri, Kurumsal Analiz ve toplu sınıf raporları için Premium gereklidir." },
    { q: "Premium paketin avantajları nelerdir?", a: "Premium (Sınırsız) Kurumsal paketi aldığınızda, tüm envanterleri ve yapay zeka raporlamalarını sınırsız kullanabilirsiniz. Okul idarenize veya velilere sunabileceğiniz Kurumsal Analizlere (Okul risk haritası, eylem planları) tam erişim sağlarsınız." },
  ];

  const detailedInventories = [
    { name: "RİBA (Öğrenci, Veli, Öğretmen)", desc: "İlkokul, ortaokul ve lise kademeleri için kurumun rehberlik ihtiyaçlarını belirleyen ve okul çapında ASP haritası çıkaran analiz." },
    { name: "Sosyometri (Sosyal İlişki Ağı)", desc: "Sınıfın interaktif sosyal ağını çizer. Liderleri, gruplaşmaları ve dışlanan öğrencileri yapay zeka desteğiyle saniyeler içinde analiz eder." },
    { name: "Holland Mesleki İlgi Envanteri", desc: "Öğrencilerin yetenek ve ilgi alanlarına göre en uygun kariyer ve meslek profillerini haritalandırır." },
    { name: "Yaşam Pencerem (Öğrenci Tanıma)", desc: "Öğrencinin ailevi, sosyal ve kişisel hayatındaki risk faktörlerini (ihmal, şiddet, istismar şüphesi) önceden tespit eder." },
    { name: "VAK & Çoklu Zeka Envanterleri", desc: "Görsel, işitsel, dokunsal öğrenme profillerini ve öğrencilerin baskın zeka türlerini belirleyerek çalışma tavsiyeleri sunar." },
    { name: "DASS-21 (Depresyon & Anksiyete)", desc: "Klinik eşikler baz alınarak öğrencinin depresyon, anksiyete ve stres düzeyini ölçen ön psikolojik tarama ölçeği." },
    { name: "Sınav Kaygısı Ölçeği", desc: "Öğrencilerin sınav öncesi ve sırasındaki bilişsel/bedensel kaygı düzeylerini ölçer, PDR müdahale planı önerir." },
    { name: "ASRS & SNAP-IV (DEHB Taraması)", desc: "Dikkat eksikliği, hiperaktivite ve karşıt gelme bozukluğu şüphelerini ölçen, aile/öğretmen ve özbildirim ölçekleri." },
    { name: "Bağımlılık ve Başarısızlık", desc: "Young İnternet Bağımlılığı, Akademik Başarısızlık ve Devamsızlık Nedenleri testleriyle risk profillerini belirler." },
    { name: "Öğrenci Bilgi & Otobiyografi", desc: "Öğrencinin aile durumunu ve kendi cümleleriyle kendini anlattığı ifadeleri yapay zeka yardımıyla analiz eden temel formlar." }
  ];

  const modalContent = {
    inventories: {
      title: "Sistemdeki Envanterler",
      icon: <Layers className="h-6 w-6 mr-3 text-blue-400"/>,
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {detailedInventories.map((inv, idx) => (
            <div key={idx} className="bg-white/5 border border-white/10 p-4 rounded-xl hover:bg-white/10 transition-colors group cursor-default">
              <h4 className="text-blue-300 font-bold mb-1.5 group-hover:text-blue-400 transition-colors">{inv.name}</h4>
              <p className="text-slate-400 text-xs leading-relaxed font-medium">{inv.desc}</p>
            </div>
          ))}
        </div>
      )
    },
    faqs: {
      title: "Sıkça Sorulan Sorular",
      icon: <HelpCircle className="h-6 w-6 mr-3 text-blue-400"/>,
      content: (
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white/[0.02] border border-white/10 rounded-xl overflow-hidden transition-all duration-300">
              <button 
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-white/[0.02] transition-colors"
              >
                <span className="font-bold text-slate-200 pr-4 text-sm">{faq.q}</span>
                <ChevronDown className={`h-4 w-4 text-slate-500 transition-transform duration-300 shrink-0 ${openFaq === index ? 'rotate-180 text-blue-400' : ''}`} />
              </button>
              {openFaq === index && (
                <div className="px-5 pb-4 pt-1 text-slate-400 text-xs leading-relaxed animate-in slide-in-from-top-2 border-t border-white/5 mt-2 pt-3 font-medium">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      )
    },
    about: {
      title: "Hakkımızda",
      icon: <ShieldCheck className="h-6 w-6 mr-3 text-blue-400"/>,
      content: <p>Rehber360, okul psikolojik danışmanlık (PDR) servislerinin dijital dönüşümünü sağlamak ve uzmanların evrak yükünü azaltmak amacıyla geliştirilmiş yeni nesil bir dijital asistan platformudur.<br/><br/>Amacımız; psikolojik danışmanların zamanlarını kağıt işlerine değil, doğrudan öğrencilere ayırmalarını sağlamaktır. Gelişmiş yapay zeka entegrasyonu ile Rehber360, okullardaki rehberlik faaliyetlerini 21. yüzyıl standartlarına taşır.</p>
    },
    privacy: {
      title: "Gizlilik Politikası",
      icon: <ShieldCheck className="h-6 w-6 mr-3 text-blue-400"/>,
      content: <p>Rehber360 olarak, kullanıcılarımızın ve özellikle öğrencilerin gizliliği en büyük önceliğimizdir.<br/><br/>Sistemimize girilen tüm hassas veriler, gelişmiş Firebase güvenlik duvarlarıyla korunmaktadır. Sistemdeki hiçbir öğrenci, bir başka öğrencinin veya sınıfın verisine erişemez. Verileriniz, hiçbir koşulda üçüncü şahıs şirketlerle veya reklam sağlayıcılarla paylaşılmaz.</p>
    },
    kvkk: {
      title: "KVKK Aydınlatma Metni",
      icon: <ShieldCheck className="h-6 w-6 mr-3 text-blue-400"/>,
      content: <p>6698 Sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca, Rehber360 altyapısına işlenen veriler konusunda bilgilendirme:<br/><br/>Rehber360, platforma girilen veriler için yalnızca 'Veri İşleyen' ve 'Yer Sağlayıcı' konumundadır. Verilerin toplanması, öğrencilerden gerekli izinlerin alınması ve verilerin hukuki sorumluluğu, sistemi kullanan kuruma ve ilgili psikolojik danışmana (Veri Sorumlusu) aittir.</p>
    },
    contact: {
      title: "İletişim & Destek",
      icon: <HelpCircle className="h-6 w-6 mr-3 text-blue-400"/>,
      content: <p>Rehber360 platformu ile ilgili soru, öneri ve destek talepleriniz için uzman ekibimizle iletişime geçebilirsiniz.<br/><br/><strong>E-Posta:</strong> destek@rehber360.net<br/><strong>Çalışma Saatleri:</strong> Hafta içi 09:00 - 17:00<br/><br/><em className="text-blue-300 opacity-80">(Not: Kurumsal üyelik ve Premium geçiş işlemleri için mail başlığına kurum adınızı yazmanızı rica ederiz.)</em></p>
    }
  };

  const handleModalClose = () => {
    setActiveModal(null);
    setOpenFaq(null); 
  };

  return (
    <div className="min-h-screen bg-[#030712] text-slate-200 font-sans selection:bg-blue-500/30 overflow-x-hidden scroll-smooth">
      
      {/* DONANIM HIZLANDIRMALI CSS (ANIMATE-MARQUEE İÇİN) */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* ARKAPLAN EFEKTLERİ (GLOW) */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-blue-900/20 blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-purple-900/20 blur-[120px]"></div>
        <div className="absolute top-[40%] left-[50%] translate-x-[-50%] w-[60%] h-[20%] rounded-full bg-indigo-900/10 blur-[150px]"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03]"></div>
      </div>

      {/* NAVBAR (GLASSMORPHISM) */}
      <nav className="fixed w-full z-50 border-b border-white/[0.05] bg-black/20 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <div className="font-black text-2xl tracking-tight text-white cursor-pointer flex items-center" onClick={() => window.scrollTo(0,0)}>
            <Brain className="h-6 w-6 mr-2 text-blue-500" />
            Rehber<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">360</span>
          </div>
          <div className="hidden md:flex items-center gap-8 font-medium text-sm text-slate-300">
            <a href="#ozellikler" className="hover:text-white transition-colors">Neden Biz?</a>
            <button onClick={() => setActiveModal('inventories')} className="hover:text-white transition-colors">
              Envanterler
            </button>
            <a href="#fiyatlandirma" className="hover:text-white transition-colors">Premium</a>
            <button onClick={() => setActiveModal('faqs')} className="hover:text-white transition-colors">
              S.S.S.
            </button>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={() => onSelect('clinician-login')} className="px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-white/10 text-white rounded-xl font-bold text-sm transition-all backdrop-blur-md">
              Giriş Yap
            </button>
          </div>
        </div>
      </nav>

      <div className="relative z-10">
        
        {/* HERO SECTION */}
        <div className="pt-40 pb-16 md:pt-52 md:pb-24 px-6">
          <div className="max-w-5xl mx-auto text-center">
            <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-blue-500/30 bg-blue-500/10 text-blue-300 text-xs font-bold tracking-widest uppercase mb-8 backdrop-blur-md">
               <Zap className="w-4 h-4 mr-2 text-blue-400"/> PDR İçin Yeni Nesil Yapay Zeka
            </div>
            <h1 className="text-5xl md:text-7xl font-black tracking-tight text-white mb-8 leading-[1.1]">
              Rehberlik Servisinin <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400">
                Dijital Dönüşümü
              </span>
            </h1>
            <p className="text-lg md:text-xl font-medium text-slate-400 max-w-3xl mx-auto leading-relaxed mb-12">
              Kağıt israfını, manuel hesaplamaları ve saatler süren raporlamayı geride bırakın. Gemini AI altyapısıyla okulunuzun psiko-sosyal haritasını saniyeler içinde çizin.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-2xl mx-auto mb-20">
              <button onClick={() => onSelect('clinician-login')} className="group relative w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white rounded-2xl font-bold text-lg transition-all overflow-hidden shadow-[0_0_40px_rgba(59,130,246,0.3)] hover:shadow-[0_0_60px_rgba(59,130,246,0.5)] border border-white/10">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out"></div>
                <span className="relative flex items-center justify-center">
                  Uzman Paneline Git <ChevronRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform"/>
                </span>
              </button>
              
              <button onClick={() => onSelect('participant-login')} className="group w-full sm:w-auto px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-2xl font-bold text-lg transition-all backdrop-blur-md flex items-center justify-center">
                <School className="h-5 w-5 mr-2 text-slate-400 group-hover:text-white transition-colors" />
                Öğrenci Girişi
              </button>
            </div>
          </div>
        </div>

        {/* 🎯 YENİ EKLENEN: WALL OF LOVE (VİTRİN YORUMLARI - MARQUEE) */}
        <div className="pb-24 pt-4 overflow-hidden relative">
          {/* Sol ve sağ kenarlarda transparanlık yaratan maske (Fade Effect) */}
          <div className="absolute inset-0 z-20 pointer-events-none [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)] bg-[#030712]/10"></div>
          
          <div className="flex w-[200%] animate-marquee hover:animation-play-state-paused">
            {/* Döngünün kesintisiz olması için aynı listeyi iki kez (2x) basıyoruz */}
            {[...testimonials, ...testimonials].map((t, index) => (
              <div 
                key={`${t.id}-${index}`} 
                className="w-[320px] md:w-[400px] shrink-0 mx-4 bg-white/5 border border-white/10 p-6 rounded-[2rem] flex flex-col justify-between backdrop-blur-sm cursor-default hover:bg-white/10 transition-colors"
              >
                <div>
                  <MessageCircle className="h-8 w-8 text-blue-500/40 mb-4"/>
                  <p className="text-slate-300 text-sm leading-relaxed mb-6">"{t.message}"</p>
                </div>
                <div className="flex items-center pt-4 border-t border-white/5">
                  <div className="h-10 w-10 bg-gradient-to-br from-blue-900 to-indigo-900 border border-blue-500/20 rounded-full flex items-center justify-center text-blue-300 font-bold text-sm shrink-0">
                    {t.userName.charAt(0)}
                  </div>
                  <div className="ml-3">
                    <p className="text-white text-sm font-bold">{t.userName}</p>
                    <p className="text-blue-400/80 text-[10px] font-bold uppercase tracking-wider">{t.userSchool}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* BENTO GRID (ÖZELLİKLER) */}
        <div id="ozellikler" className="py-24 px-6 border-t border-white/5 bg-black/20">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-black text-white mb-4">Neden Rehber360?</h2>
              <p className="text-slate-400 font-medium text-lg max-w-2xl mx-auto">Sıradan bir anket sitesi değil, veriyi anlama dönüştüren akıllı bir asistan.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 auto-rows-[minmax(180px,auto)]">
              
              <div className="md:col-span-2 lg:col-span-2 md:row-span-2 bg-gradient-to-br from-blue-900/40 to-purple-900/40 border border-white/10 rounded-[2rem] p-8 relative overflow-hidden group hover:border-blue-500/50 transition-colors backdrop-blur-md flex flex-col justify-between">
                <div className="absolute top-0 right-0 p-8 opacity-20 group-hover:opacity-40 group-hover:scale-110 transition-all duration-700">
                  <Brain className="w-48 h-48 text-blue-400" />
                </div>
                <div className="relative z-10">
                  <div className="h-12 w-12 bg-blue-500/20 border border-blue-500/30 rounded-xl flex items-center justify-center mb-6">
                    <Brain className="h-6 w-6 text-blue-400" />
                  </div>
                  <h3 className="text-3xl font-black text-white mb-4">Yapay Zeka Raporlama</h3>
                  <p className="text-slate-300 text-base leading-relaxed max-w-md">
                    Saatler, haftalar, aylar süren manuel analizleri unutun. Öğrencinin anket yanıtlarını veya açık uçlu yazılarını Yapay Zeka(AI) anında işler ve <strong>profesyonel bir psiko-sosyal rapora</strong> dönüştürür.
                  </p>
                </div>
              </div>

              <div className="md:col-span-1 lg:col-span-2 bg-white/[0.02] border border-white/10 rounded-[2rem] p-8 relative group hover:bg-white/[0.04] transition-colors backdrop-blur-md flex flex-col justify-center">
                <div className="h-12 w-12 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center mb-4">
                  <FileText className="h-6 w-6 text-emerald-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Dijital Envanterler</h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  RİBA, Holland İlgi Envanteri, Sosyometri, Yaşam Pencerem, Devamsızlık Nedenleri dahil tüm MEB testlerini kağıt kullanmadan saniyeler içinde uygulayın.
                </p>
              </div>

              <div className="md:col-span-1 lg:col-span-1 bg-white/[0.02] border border-white/10 rounded-[2rem] p-8 relative group hover:bg-white/[0.04] transition-colors backdrop-blur-md flex flex-col justify-center">
                <div className="h-12 w-12 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center mb-4">
                  <BarChart className="h-6 w-6 text-orange-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Mükemmel Çıktılar</h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  Mobil uyumlu, "Dergi Kalitesinde" PDF raporları ve resmi Excel arşivleri ile sunumlarınızı renklendirin.
                </p>
              </div>

              <div className="md:col-span-1 lg:col-span-1 bg-gradient-to-br from-red-900/20 to-transparent border border-red-500/20 rounded-[2rem] p-8 relative group hover:border-red-500/50 transition-colors backdrop-blur-md flex flex-col justify-center">
                <div className="h-12 w-12 bg-red-500/20 border border-red-500/30 rounded-xl flex items-center justify-center mb-4">
                  <ShieldAlert className="h-6 w-6 text-red-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Akıllı Risk Filtresi</h3>
                <p className="text-red-200/70 text-sm leading-relaxed">
                  İhmal, depresyon veya şiddet barındıran maddeleri sistem anında tespit edip "Kırmızı Alarm" verir.
                </p>
              </div>

              <div className="md:col-span-3 lg:col-span-4 bg-white/[0.02] border border-white/10 rounded-[2rem] p-8 relative group hover:bg-white/[0.04] transition-colors backdrop-blur-md flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div className="max-w-xl">
                  <div className="h-12 w-12 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center mb-4">
                    <Users className="h-6 w-6 text-purple-400" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3">360° Sınıf Dinamiği ve Sosyogram</h3>
                  <p className="text-slate-400 text-base leading-relaxed">
                    Öğrencilerin ilişki ağını (Sosyogram) interaktif grafiklerle çizin. Sınıftaki liderleri, gruplaşmaları ve dışlanan öğrencileri yapay zeka desteğiyle saniyeler içinde analiz edin.
                  </p>
                </div>
                <div className="hidden md:flex flex-1 justify-end opacity-50 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="relative w-48 h-32">
                    <div className="absolute top-4 left-4 w-8 h-8 rounded-full border-2 border-amber-500 bg-amber-500/20"></div>
                    <div className="absolute bottom-4 right-8 w-6 h-6 rounded-full border-2 border-red-500 bg-red-500/20"></div>
                    <div className="absolute top-12 right-20 w-8 h-8 rounded-full border-2 border-blue-500 bg-blue-500/20"></div>
                    <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
                      <path d="M 40,30 Q 80,10 130,60" fill="transparent" stroke="#6366f1" strokeWidth="2" strokeDasharray="4 4" />
                      <path d="M 130,60 Q 150,90 170,100" fill="transparent" stroke="#6366f1" strokeWidth="2" strokeDasharray="4 4" />
                    </svg>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* FİYATLANDIRMA (GLASS CARDS) */}
        <div id="fiyatlandirma" className="py-24 px-6 border-t border-white/5 relative">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"></div>
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-black text-white mb-4">Kurumunuz İçin Güçlü Planlar</h2>
              <p className="text-slate-400 font-medium text-lg">Dijital dönüşüme ücretsiz başlayın veya kurumunuzu zirveye taşıyın.</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-white/[0.02] border border-white/10 p-10 rounded-[2.5rem] backdrop-blur-md flex flex-col">
                <h3 className="text-2xl font-bold text-white mb-2">Standart</h3>
                <div className="text-4xl font-black text-white mb-6">Ücretsiz</div>
                <ul className="space-y-4 mb-8 flex-1">
                  <li className="flex items-center text-slate-400 text-sm"><Check className="h-5 w-5 text-slate-500 mr-3 shrink-0"/> Temel Öğrenci Bilgi Formu</li>
                  <li className="flex items-center text-slate-400 text-sm"><Check className="h-5 w-5 text-slate-500 mr-3 shrink-0"/> Sınırlı Sınıf ve Öğrenci Ekleme</li>
                  <li className="flex items-center text-slate-400 text-sm"><Check className="h-5 w-5 text-slate-500 mr-3 shrink-0"/> Standart Yapay Zeka Raporlaması</li>
                  <li className="flex items-center text-slate-400 text-sm"><Check className="h-5 w-5 text-slate-500 mr-3 shrink-0"/> Her envanter için 5 öğrenci limiti</li>
                </ul>
                <button onClick={() => onSelect('clinician-login')} className="w-full py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-xl font-bold transition-all">Hemen Başla</button>
              </div>

              <div className="bg-gradient-to-b from-blue-900/40 to-slate-900/40 border border-blue-500/30 p-10 rounded-[2.5rem] relative overflow-hidden transform md:-translate-y-4 shadow-[0_0_50px_rgba(59,130,246,0.15)] flex flex-col">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/20 blur-3xl"></div>
                <div className="absolute top-6 right-6 bg-blue-500/20 border border-blue-400/30 text-blue-300 text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest flex items-center shadow-lg backdrop-blur-md">
                  <Star className="h-3 w-3 mr-1.5"/> PRO
                </div>
                <h3 className="text-2xl font-bold text-white mb-2 relative z-10">Premium Kurumsal</h3>
                
                {/* EYLÜL AYI KAMPANYA BLOKU */}
<div className="mt-2 mb-6 relative z-10">
  <div className="flex items-center gap-2 mb-1">
    <span className="text-lg font-bold text-slate-400 line-through decoration-rose-500/80 decoration-2">
      1.000 ₺
    </span>

    <span className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-2.5 py-0.5 rounded-full text-[10px] font-black tracking-widest shadow-md animate-pulse">
      EYLÜL AYINA ÖZEL
    </span>
  </div>

  <div className="flex items-end">
    <span className="text-5xl font-black text-white tracking-tighter">750</span>
    <span className="text-2xl font-bold text-slate-300 ml-1 mb-1">₺</span>
    <span className="text-sm font-bold text-slate-400 ml-1 mb-1.5">/ Yıllık</span>
  </div>

  <p className="text-xs font-bold text-emerald-400 mt-2">
    ✨ Eylül boyunca %25 indirimle yeni döneme avantajlı başlayın.
  </p>
</div>
                <ul className="space-y-4 mb-8 flex-1 relative z-10">
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> Sınırsız Sınıf ve Öğrenci Yönetimi</li>
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> <strong>Tüm Envanterler</strong> (Sosyometri, RİBA, ASRS vb.)</li>
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> <strong>Sınırsız Yapay Zeka (AI)</strong> Raporlaması</li>
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> Gelişmiş PDF Çıktıları ve Kurumsal Excel Arşivi</li>
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> AI İçerik Atölyesi ile kendi içeriklerini üret</li>
                  <li className="flex items-start text-blue-100 text-sm"><Check className="h-5 w-5 text-blue-400 mr-3 shrink-0 mt-0.5"/> Premium evraklardan oluşan Döküman Çantası</li>
                </ul><button onClick={() => onSelect('clinician-login')} className="relative z-10 w-full py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold transition-all shadow-[0_0_20px_rgba(59,130,246,0.4)]">Premium'a Geç</button>
                <div className="relative z-10 mt-4 flex items-center justify-center text-blue-200/70 text-[11px] font-medium">
                  <ShieldCheck className="h-4 w-4 mr-1.5" />
                  <span><strong>Shopier</strong> güvencesiyle 12 aya varan taksit imkanı</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* GÜVENLİK ALANI */}
        <div className="py-16 border-y border-white/5 bg-gradient-to-b from-transparent to-blue-900/10">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <ShieldCheck className="h-16 w-16 text-blue-500/80 mx-auto mb-6" />
            <h2 className="text-2xl font-black text-white mb-4">Verileriniz ve Ödemeleriniz Banka Düzeyinde Güvende</h2>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 font-medium">
              Rehber360, öğrenci verilerinin gizliliğini en üst düzeyde tutar. Verileriniz Firebase güvenlik duvarlarıyla uçtan uca şifrelenir. Hiçbir öğrenci başka bir öğrencinin verisine erişemez. <strong>Premium ödemeleriniz ise BDDK onaylı Shopier altyapısıyla 256-bit SSL sertifikasıyla korunur.</strong> Sistemimiz KVKK standartlarına tam uyumludur.
            </p>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="bg-black/40 border-t border-white/5 text-slate-500 py-12 text-center text-sm relative z-10 backdrop-blur-xl">
          <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
            <div className="font-black text-white text-xl tracking-tight mb-6 md:mb-0 cursor-pointer" onClick={() => window.scrollTo(0,0)}>
              Rehber<span className="text-blue-500">360</span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-6 md:mb-0">
              <button onClick={() => setActiveModal('inventories')} className="hover:text-blue-400 transition font-medium">Envanterler</button>
              <button onClick={() => setActiveModal('faqs')} className="hover:text-blue-400 transition font-medium">S.S.S.</button>
              <button onClick={() => setActiveModal('about')} className="hover:text-white transition font-medium">Hakkımızda</button>
              <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition font-medium">Gizlilik Politikası</button>
              <button onClick={() => setActiveModal('kvkk')} className="hover:text-white transition font-medium">KVKK</button>
              <button onClick={() => setActiveModal('contact')} className="hover:text-white transition font-medium">İletişim</button>
            </div>
            <div className="font-medium text-xs">
              © 2026 Rehber360. Tüm Hakları Saklıdır.
            </div>
          </div>
        </footer>

      </div>

      {/* DİNAMİK MODAL (GLASSMORPHISM) */}
      {activeModal && modalContent[activeModal] && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-md animate-in fade-in duration-300">
          <div className="bg-slate-900 border border-white/10 w-full max-w-3xl rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
            <div className="flex justify-between items-center p-6 border-b border-white/5 bg-white/5">
              <h3 className="text-xl font-black text-white flex items-center">
                {modalContent[activeModal].icon} 
                {modalContent[activeModal].title}
              </h3>
              <button onClick={handleModalClose} className="p-2 rounded-full hover:bg-white/10 text-slate-400 hover:text-white transition">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="p-6 text-slate-300 leading-relaxed text-sm max-h-[65vh] overflow-y-auto custom-scrollbar">
              {modalContent[activeModal].content}
            </div>
            <div className="p-5 border-t border-white/5 bg-white/5 flex justify-end">
              <button onClick={handleModalClose} className="px-6 py-2.5 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-500 transition shadow-lg shadow-blue-500/20">
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default LandingPage;